

// import React from "react";
// import logo from "../assests/logo.png";

// import {
//   FaFacebookF,
//   FaInstagram,
//   FaLinkedinIn,
//   FaWhatsapp,
//   FaMapMarkerAlt,
//   FaPhoneAlt,
//   FaEnvelope,
// } from "react-icons/fa";

// const Footer = () => {
//   return (
//     <footer className="bg-gradient-to-r from-[#0B3D02] via-[#145A32] to-[#0B3D02] text-white pt-14">

//       <div className="max-w-7xl mx-auto px-6">

//         <div className="grid lg:grid-cols-3 gap-16">

//           {/* Company */}

//           <div>

//             <div className="bg-white rounded-2xl inline-block p-4 shadow-2xl">
//               <img
//                 src={logo}
//                 alt="DV Coconut Logo"
//                 className="h-24 object-contain"
//               />
//             </div>

//             <p className="mt-8 text-gray-200 leading-8 text-lg">
//               DV Coconut Farms is a trusted supplier of premium-quality
//               coconut products. We provide fresh coconuts, tender coconuts,
//               copra, coconut oil, coconut leaves, coconut shells and other
//               coconut-based products directly from our farms to retailers,
//               wholesalers, exporters and bulk buyers.
//             </p>

//             <div className="flex gap-4 mt-8">

//               <a
//                 href="#"
//                 className="w-12 h-12 rounded-full bg-green-700 hover:bg-blue-600 transition flex justify-center items-center"
//               >
//                 <FaFacebookF />
//               </a>

//               <a
//                 href="#"
//                 className="w-12 h-12 rounded-full bg-green-700 hover:bg-pink-600 transition flex justify-center items-center"
//               >
//                 <FaInstagram />
//               </a>

//               <a
//                 href="#"
//                 className="w-12 h-12 rounded-full bg-green-700 hover:bg-blue-500 transition flex justify-center items-center"
//               >
//                 <FaLinkedinIn />
//               </a>

//               <a
//                 href="#"
//                 className="w-12 h-12 rounded-full bg-green-700 hover:bg-green-500 transition flex justify-center items-center"
//               >
//                 <FaWhatsapp />
//               </a>

//             </div>

//           </div>

//           {/* Products */}

//           <div>

//             <h2 className="text-3xl font-bold text-green-300">
//               Our Products
//             </h2>

//             <div className="w-20 h-1 bg-green-300 rounded-full mt-3 mb-8"></div>

//             <div className="grid grid-cols-2 gap-y-6 gap-x-10">

//               <div className="space-y-6">

//                 <div className="flex items-center gap-3">
//                   🥥 <span>Fresh Coconut</span>
//                 </div>

//                 <div className="flex items-center gap-3">
//                   🥥 <span>Copra</span>
//                 </div>

//                 <div className="flex items-center gap-3">
//                   🌴 <span>Coconut Leaves</span>
//                 </div>

//               </div>

//               <div className="space-y-6">

//                 <div className="flex items-center gap-3">
//                   🥥 <span>Tender Coconut</span>
//                 </div>

//                 <div className="flex items-center gap-3">
//                   🛢️ <span>Coconut Oil</span>
//                 </div>

//                 <div className="flex items-center gap-3">
//                   🥥 <span>Coconut Shell</span>
//                 </div>

//               </div>

//             </div>

//           </div>

//           {/* Contact */}

//           <div>

//             <h2 className="text-3xl font-bold text-green-300">
//               Contact Us
//             </h2>

//             <div className="w-20 h-1 bg-green-300 rounded-full mt-3 mb-8"></div>

//             <div className="space-y-8">

//               <div className="flex items-center gap-5">

//                 <div className="w-14 h-14 rounded-full bg-green-700 flex justify-center items-center">
//                   <FaMapMarkerAlt />
//                 </div>

//                 <div>
//                   <p>Krishnagiri</p>
//                   <p>Tamil Nadu, India</p>
//                 </div>

//               </div>

//               <div className="flex items-center gap-5">

//                 <div className="w-14 h-14 rounded-full bg-green-700 flex justify-center items-center">
//                   <FaPhoneAlt />
//                 </div>

//                 <p>+91 99945 48118</p>

//               </div>

//               <div className="flex items-center gap-5">

//                 <div className="w-14 h-14 rounded-full bg-green-700 flex justify-center items-center">
//                   <FaEnvelope />
//                 </div>

//                 <p className="break-all">
//                   gowthamv187@gmail.com
//                 </p>

//               </div>

//             </div>

//           </div>

//         </div>

//         {/* Bottom */}

//         <div className="border-t border-green-700 mt-14 pt-6 pb-6">

//           <div className="flex flex-col md:flex-row justify-between items-center">

//             <div className="flex gap-8 order-2 md:order-1 mt-4 md:mt-0">

//               <a
//                 href="#"
//                 className="hover:text-green-300 transition"
//               >
//                 Privacy Policy
//               </a>

//               <a
//                 href="#"
//                 className="hover:text-green-300 transition"
//               >
//                 Terms & Conditions
//               </a>

//             </div>

//             <p className="order-1 md:order-2 text-center text-gray-300">
//               © {new Date().getFullYear()}{" "}
//               <span className="text-green-300 font-semibold">
//                 DV Coconut Farms
//               </span>{" "}
//               | All Rights Reserved.
//             </p>

//           </div>

//         </div>

//       </div>

//     </footer>
//   );
// };

// export default Footer;

import React from "react";
import logo from "../assests/logo.png";

import {
  FaFacebookF,
  FaInstagram,
  FaLinkedinIn,
  FaWhatsapp,
  FaMapMarkerAlt,
  FaPhoneAlt,
  FaEnvelope,
} from "react-icons/fa";

const Footer = () => {
  return (
    <footer className="bg-gradient-to-r from-[#0B3D02] via-[#145A32] to-[#0B3D02] text-white pt-16 pb-6">

      <div className="max-w-7xl mx-auto px-5 sm:px-8 lg:px-10">

        {/* Main Footer */}

        <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 gap-12 lg:gap-16">

          {/* Company */}

          <div>

            <div className="bg-white rounded-2xl inline-block p-4 shadow-2xl">

              <img
                src={logo}
                alt="DV Coconut Logo"
                className="h-20 sm:h-24 lg:h-28 w-auto object-contain"
              />

            </div>

            <p className="mt-8 text-gray-200 leading-8 text-base lg:text-lg">

              DV Coconut Farms is a trusted supplier of premium-quality
              coconut products. We provide fresh coconuts, tender coconuts,
              copra, coconut oil, coconut leaves, coconut shells and other
              coconut-based products directly from our farms to retailers,
              wholesalers, exporters and bulk buyers.

            </p>

            {/* Social Icons */}

            <div className="flex flex-wrap gap-4 mt-8">

              <a
                href="#"
                className="w-12 h-12 rounded-full bg-green-700 hover:bg-blue-600 transition duration-300 flex justify-center items-center"
              >
                <FaFacebookF />
              </a>

              <a
                href="#"
                className="w-12 h-12 rounded-full bg-green-700 hover:bg-pink-600 transition duration-300 flex justify-center items-center"
              >
                <FaInstagram />
              </a>

              <a
                href="#"
                className="w-12 h-12 rounded-full bg-green-700 hover:bg-blue-500 transition duration-300 flex justify-center items-center"
              >
                <FaLinkedinIn />
              </a>

              <a
                href="#"
                className="w-12 h-12 rounded-full bg-green-700 hover:bg-green-500 transition duration-300 flex justify-center items-center"
              >
                <FaWhatsapp />
              </a>

            </div>

          </div>

          {/* Products */}

          <div>

            <h2 className="text-2xl lg:text-3xl font-bold text-green-300">
              Our Products
            </h2>

            <div className="w-20 h-1 bg-green-300 rounded-full mt-3 mb-8"></div>

            <div className="grid grid-cols-1 sm:grid-cols-2 gap-5">

              <div className="space-y-5">

                <p className="flex items-center gap-3 text-base lg:text-lg">
                  🥥 Fresh Coconut
                </p>

                <p className="flex items-center gap-3 text-base lg:text-lg">
                  🥥 Copra
                </p>

                <p className="flex items-center gap-3 text-base lg:text-lg">
                  🌴 Coconut Leaves
                </p>

              </div>

              <div className="space-y-5">

                <p className="flex items-center gap-3 text-base lg:text-lg">
                  🥥 Tender Coconut
                </p>

                <p className="flex items-center gap-3 text-base lg:text-lg">
                  🛢️ Coconut Oil
                </p>

                <p className="flex items-center gap-3 text-base lg:text-lg">
                  🥥 Coconut Shell
                </p>

              </div>

            </div>

          </div>

          {/* Contact */}

          <div>

            <h2 className="text-2xl lg:text-3xl font-bold text-green-300">
              Contact Us
            </h2>

            <div className="w-20 h-1 bg-green-300 rounded-full mt-3 mb-8"></div>

            <div className="space-y-6">

              <div className="flex items-start gap-4">

                <div className="w-12 h-12 lg:w-14 lg:h-14 rounded-full bg-green-700 flex justify-center items-center flex-shrink-0">

                  <FaMapMarkerAlt />

                </div>

                <div>

                  <p className="font-semibold">
                    Address
                  </p>

                  <p className="text-gray-200 leading-7">
                    Krishnagiri,
                    <br />
                    Tamil Nadu, India
                  </p>

                </div>

              </div>

              <div className="flex items-center gap-4">

                <div className="w-12 h-12 lg:w-14 lg:h-14 rounded-full bg-green-700 flex justify-center items-center flex-shrink-0">

                  <FaPhoneAlt />

                </div>

                <div>

                  <p className="font-semibold">
                    Phone
                  </p>

                  <p className="text-gray-200">
                    +91 99945 48118
                  </p>

                </div>

              </div>

              <div className="flex items-center gap-4">

                <div className="w-12 h-12 lg:w-14 lg:h-14 rounded-full bg-green-700 flex justify-center items-center flex-shrink-0">

                  <FaEnvelope />

                </div>

                <div>

                  <p className="font-semibold">
                    Email
                  </p>

                  <p className="text-gray-200 break-all">
                    gowthamv187@gmail.com
                  </p>

                </div>

              </div>

            </div>

          </div>

        </div>

        {/* Bottom */}

        <div className="border-t border-green-700 mt-12 pt-6">

          <div className="flex flex-col lg:flex-row items-center justify-between gap-4">

            <p className="text-center text-gray-300 text-sm sm:text-base">

              © {new Date().getFullYear()}{" "}

              <span className="font-semibold text-green-300">
                DV Coconut Farms
              </span>

              {" "}All Rights Reserved.

            </p>

            <div className="flex flex-wrap justify-center gap-6 text-sm sm:text-base">

              <a
                href="#"
                className="hover:text-green-300 transition"
              >
                Privacy Policy
              </a>

              <a
                href="#"
                className="hover:text-green-300 transition"
              >
                Terms & Conditions
              </a>

            </div>

          </div>

        </div>

      </div>

    </footer>
  );
};

export default Footer;